// src/routes/crmRoutes.ts

import { lazy } from "react";
import { RouteProperties } from "./routes";
import CompanyForm from "../pages/CRM/Companies/CompanyForm";

// Lazy load CRM pages
const ContactList = lazy(() => import("../pages/CRM/Contacts/ContactList"));
const ContactDetail = lazy(() => import("../pages/CRM/Contacts/ContactDetail"));
const ContactForm = lazy(() => import("../pages/CRM/Contacts/components/ContactForm"));
const ContactImport = lazy(() => import("../pages/CRM/Contacts/ContactImport"));

const CompanyList = lazy(() => import("../pages/CRM/Companies/CompanyList"));
const CompanyDetail = lazy(() => import("../pages/CRM/Companies/CompanyDetail"));

const DealPipeline = lazy(() => import("../pages/CRM/Deals/DealPipeline"));
const DealList = lazy(() => import("../pages/CRM/Deals/DealList"));
const DealDetail = lazy(() => import("../pages/CRM/Deals/DealDetail"));

const ActivityCalendar = lazy(() => import("../pages/CRM/Activities/ActivityCalendar"));
const ActivityList = lazy(() => import("../pages/CRM/Activities/ActivityList"));

const CRMReports = lazy(() => import("../pages/CRM/Reports/CRMReports"));
const UserList = lazy(() => import("../pages/CRM/Users/UserList"));

// CRM Route Paths
export const crmRoutePaths = {
    // Contacts
    contacts: "/crm/contacts",
    contactDetail: "/crm/contacts/:id",
    contactNew: "/crm/contacts/new",
    contactEdit: "/crm/contacts/:id/edit",
    contactImport: "/crm/contacts/import",

    // Companies
    companies: "/crm/companies",
    companyDetail: "/crm/companies/:id",
    companyNew: "/crm/companies/new",
    companyEdit: "/crm/companies/:id/edit",

    // Deals
    dealsPipeline: "/crm/deals/pipeline",
    deals: "/crm/deals",
    dealDetail: "/crm/deals/:id",
    dealNew: "/crm/deals/new",

    // Activities
    activitiesCalendar: "/crm/activities/calendar",
    activities: "/crm/activities",
    activitiesNew: "/crm/activities/new",

    // Reports
    reports: "/crm/reports",
    salesReport: "/crm/reports/sales",
    activityReport: "/crm/reports/activities",

    // Users
    users: "/crm/users",
};

// CRM Routes Configuration
export const crmRoutes: RouteProperties[] = [
    // Contacts Routes
    {
        path: crmRoutePaths.contacts,
        element: ContactList,
    },
    {
        path: crmRoutePaths.contactDetail,
        element: ContactDetail,
    },
    {
        path: crmRoutePaths.contactNew,
        element: ContactForm,
    },
    {
        path: crmRoutePaths.contactEdit,
        element: ContactForm,
    },
    {
        path: crmRoutePaths.contactImport,
        element: ContactImport,
    },

    // Companies Routes
    {
        path: crmRoutePaths.companies,
        element: CompanyList,
    },
    {
        path: crmRoutePaths.companyDetail,
        element: CompanyDetail,
    },
    {
        path: crmRoutePaths.companyNew,
        element: CompanyForm,
    },
    {
        path: crmRoutePaths.companyEdit,
        element: CompanyForm,
    },

    // Deals Routes
    {
        path: crmRoutePaths.dealsPipeline,
        element: DealPipeline,
    },
    {
        path: crmRoutePaths.deals,
        element: DealList,
    },
    {
        path: crmRoutePaths.dealDetail,
        element: DealDetail,
    },

    // Activities Routes
    {
        path: crmRoutePaths.activitiesCalendar,
        element: ActivityCalendar,
    },
    {
        path: crmRoutePaths.activities,
        element: ActivityList,
    },

    // Reports Routes
    {
        path: crmRoutePaths.reports,
        element: CRMReports,
    },

    // Users Routes
    {
        path: crmRoutePaths.users,
        element: UserList,
    },
];
